import { Link } from "react-router-dom"; 
import CollapseSection from "../../components/CollapseSection/CollapseSection";
import CollapseSectionSimple from "../../components/CollapseSectionSimple/CollapseSectionSimple";
import ModalImage from "react-modal-image";

import classes from "./styles.scss";

const data = [
	{
		title: "Ден 1",
		date: "05 ноември 2022 г.",
		destination: "София – Богота",
		others: "(вечеря)",
		text: <div>Приключението ни заедно започва на летище София, където ще Ви очаква водачът на групата. След първи запознанства отпътуваме за Богота с прекачване във Франкфурт. Същият ден, привечер, пристигаме на международното летище Ел Дорадо в Богота. Трансфер до хотела, настаняване в <a className={classes.textLink} href="https://www.ihg.com/holidayinnexpress/hotels/us/en/bogota/bogex/hoteldetail" target="_blank">Holiday Inn Express – Parque la 93 4*</a>, или подобен и вечеря. Свободно време за почивка, първи впечатления от колумбийската столица и климатизация.</div>
	}, 
	{
		title: "Ден 2",
		date: "06 ноември 2022 г.",
		destination: "Богота",
		others: "(обяд)",
		text: <div>Закуска в хотела. Първият ден от пътуването ни е посветен на Богота, градът на звездите. Обиколката ни започва с историческия квартал Канделария, където ще се разходим пеша из колоритните му улички. След това ще се насочим към историческия му център, за да обходим Площад Боливар. По-късно ще посетим Музея на златото. Музеят е отворен през 1939 г. и е смятан за един от най-важните в света, защото пази изумителна колекция от над 32 хиляди предмети от злато, скъпоценни камъни и керамика от предколумбовия период. Оттам ще се насочим към висините на хълма Монсерате с неговите 3 152 м. (по-висок от българския първенец, връх Мусала), който ще изкачим с лифт или зъбчата железница (фуникулер), за да се насладим на изумителните гледки към колумбийската столица и Андите. На върха ще видим светилището Монсерате, символ на града. Там, по-близо до небето, ще е и нашият обяд. <p>След обяд ще продължим разходката си по Карера 7, главната улица в колониалния период и една от основните съвременни артерии на града. Панорамната ни обиколка с превозно средство (ван или микробус или автобус) ще премине през оживените булеварди на Богота, покрай паркове, търговски и бизнес сгради в зона Т и зона Роса, известни със своите барове, дистотеки и магазини.</p><p>Връщане в хотела. Свободно време за вечеря и почивка.</p></div>
	},
	{
		title: "Ден 3",
		date: "07 ноември 2022 г.",
		destination: "Богота – лагуната Гуатавита и Сипакира ",
		others: "(обяд)",
		text: <div>Този ден ще изследваме околностите на Богота. След закуска ще потеглим с нашия транспорт към свещената лагуна Гуатавита, където, според легендите, се е извършвал ритуалът Ел Дорадо. По-късно ще се насочим към Сипакира и там ще обядваме в традиционен ресторант. Следобед ще посетим едно от най-големите чудеса на Колумбия – солната катедрала на Сипакира, разположена на 180 м. под земята. Вечерта ще се върнем в Богота. Свободно време за вечеря и почивка. <br/><i>* Влизането в солната катедрала не е препоръчителна за хора с астма и клаустрофобия.</i></div>
	}, 
	{
		title: "Ден 4",
		date: "08 ноември 2022 г.",
		destination: "Богота – Армения – Саленто ",
		others: "(обяд и вечеря)",
		text: <div>След закуска ще се отправим към летище Ел Дорадо в Богота и с кратък вътрешен полет ще достигнем до град Армения, разположен в сърцето на Зоната на кафето. От летището на Армения ще направим трансфер до едно от най-очарователните колониални градчета на Колумбия, Саленто. След пристигането в града ще имаме организиран обяд, а след това ще се настаним в хотел <a  className={classes.textLink} href="https://en.hotelsalentoreal.com/" target="_blank">Salento Real 4*</a>, или подобен. Днес денят ще е по-лежерен и всеки ще има свободно време, в което да се отдаде на разходка из колоритните улички на града и да усети атмосферата на колониална Колумбия. Включена вечеря.</div>
	},
	{
		title: "Ден 5",
		date: "09 ноември 2022 г.",
		destination: "Саленто – тур на кафето ",
		others: "(обяд и вечеря)",
		text: <div>
            След като закусим ще се отправим към Санта Роса де Кабал, за да посетим кафеена плантация, разположена на 1500 метра по склоновете на Андите. Местните експерти ще ни разходят из кафеените плантации и ще ни обяснят целия процес по производство на кафето, от засяването и събирането, до изпичането на зърната. Ще имаме възможност да участваме в изпичането на кафеените зърна в специално приготвена за целта фурна. По време на посещението ще имаме възможност да се насладим на прекрасния пейзаж на околността от няколко панорамни площадки, докато опитваме от кафето, което приготвят. Накрая ще ни изпратят с вкусна домашна лимонада от кафе.
            Следва обяд в местен ресторант и посещение на Ботаническата градина на демартамента Киндио. Връщане в Саленто и вечеря. Време за почивка.</div>
	},
	{
		title: "Ден 6",
		date: "10 ноември 2022 г.",
		destination: "Саленто – Вайе дел Кокора – Филандия ",
		others: "(обяд и вечеря)",
		text: <div>Сутринта е време за закуска, а след нея ще се отправим към долината Вайе дел Кокора, част от националния парк Лос Невадос. Този ден ще се насладим на изумителните зелени пейзажи на Андите. Вайе дел Кокора е идеалното място, където могат да се видят восъчните палми – националното дърво на Колумбия, което достига до 60 м. височина. Този ден за транспорт ще използваме джипове Willys, типични за региона превозни средства, с които се транспортират хора и кафе. По специална екопътека ще навлезем в облачната гора, която пресича река Киндио, и ще се доближим максимално най-близо до палмите. Нашият обяд ще е в местен ресторант, а по-късно следобед ще се разходим из центъра на Саленто, за да усетим неповторимата му колониална атмосфера. Днес сме предвидили и посещение на съседното очарователно градче Филандия и неговия център. По-късно ще изкачим наблюдателницата на Киндио и ще видим цялата долина от птичи поглед. Включена вечеря. Нощувка.</div>
	},
	{
		title: "Ден 7",
		date: "11 ноември 2022 г.",
		destination: "Саленто – Армения – Меделин",
		others: "",
		text: <div>След закуска, свободна сутрин и трансфер до летището на Армения. Оттук ще вземем вътрешен полет до Меделин с прекачване в Богота. В ранния следобед ще пристигнем в Меделин, след което ще бъдем трансферирани и настанени в <a className={classes.textLink} href="https://en.estelarmilladeoro.com/" target="_blank">Estelar Мilla de Оro 5*</a>, или подобен. В този ден храненията за обяд и вечеря се организират от всеки самостоятелно. Нощувка.</div>
	},
	{
		title: "Ден 8",
		date: "12 ноември 2022 г.",
		destination: "Меделин ",
		others: "(обяд)",
		text: <div>Закуска в хотела. Този ден сме го определили за Меделин, един от най-очарователните градове на Колумбия, известен като “градът на вечната пролет”. Първо с метро, а след това с лиф ще се придвижим до парка Арви, за да му се насладим и разходим пеша. По-късно тук ще ни чака превозното ни средство и с него ще достигнем до центъра на града, за да направим панорамна обиколка. Тя ще завърши с Парка на скулптурите, включващ над 20 произведения на Фернандо Ботеро, дарени лично от него на града. Включен обяд и посещение на Колона 13, едно от най-емблематичните места в града. По-късно ще се повозим на емблематичните електрически стълби, ще ядем сладолед и ще се потопим в историята, настоящето и бъдещето на този изумителен град. Лично време за почивка и вечеря. Нощувка.</div>
	},
	{
		title: "Ден 9",
		date: "13 ноември 2022 г.",
		destination: "Меделин – Гуатапе – Меделин ",
		others: "(обяд)",
		text: <div>Закуска в хотела. Днес ще се насочим към Гуатапе, извън Меделин, за да се порадваме на един от най-красивите пейзажи на този департамент. Сред	 безкрайните зелени поля, обгърнали изкуственото езеро Гуатапе, се издига Ел Пеньол, скала с над 200 метра височина. Осмелилите се да изкачат 710-те стъпала, които водят към върха, ще бъдат възнаградени с незабравими гледки към езерото и целия регион. Следва посещение на колоритното градче Гуатапе, известно като “най-цветния град на Колумбия”. Местните жители пазят традицията да боядисват фасадите на къщите си в ярки цветове, а често по тях са изрисувани сцени от живота на фамилията, която ги обитава. За да усетим максимално уникалната атмосфера на този цветен град, сме предвидили и да се повозим и на мототакси (тук-тук). Организиран обяд в традиционен ресторант и връщане в Меделин. Свободно време за вечеря и почивка.</div>
	},
	{
		title: "Ден 10",
		date: "14 ноември 2022 г.",
		destination: "Меделин – Картахена де Индиас",
		others: "",
		text: <div>Закуска и трансфер до летището на Меделин. Оттук с директен вътрешен полет ще стигнем до Картахена де Индиас, перлата на колумбийското карибско крайбрежие. Пристигане в Картахена, трансфер и настаняване в хотел <a className={classes.textLink} href="https://www.hilton.com/en/hotels/ctgmaqq-nacar-hotel-cartagena/" target="_blank">Nacar Curio Collection by Hilton 4 SUP*</a>, или подобен, разположен в историческия център на града. В този ден храненията за обяд и вечеря се организират самостоятелно, като всеки ще има възможност да се отдаде на почивка или лично да открие любимото си място в града.</div>
	},
	{
		title: "Ден 11",
		date: "15 ноември 2022 г.",
		destination: "Картахена де Индиас ",
		others: "(обяд)",
		text: <div>Закуска в хотела. Ще се уверите, че си заслужава да отделим целия ден на този колоритен колониален град, включен в световното наследство на ЮНЕСКО. Отправна точка на нашата обиколка ще бъде крепостта Сан Фелипе де Барахас, където ще се „изгубим“ из тесните тунели и галерии на това впечатляващо крепостно съоржение, изградено за защита на града от набезите на пиратите. Следват посещения на манастира и църквата Сан Педро Клавер, изградени през 17 век; занаятчийския център Лас Боведас, създаден първоначално като оръжейница, а по-късно използван и като затвор. Обяд в местен ресторант. Сводобен следобед, за да може всеки да продължи с личните си „открития“ на чудесата на този уникален град. Време за вечеря и почивка.</div>
	},
	{
		title: "Ден 12",
		date: "16 ноември 2022 г.",
		destination: "Картахена де Индиас – островите Росарио – Картахена де Индиас",
		others: "(обяд)",
		text: <div>След закуска ще се отправим пеша към кея на града и ще се качим на бързи моторни лодки за едно незабравимо плаване в Карибско море. Нашата цел са островите Росарио, разположени на час път с лодка от Картахена. След като напуснем залива на града, ще преминем покрай остров Тиера Бомба и ще видим неговите три крепости от открито море. На главния остров ще ни очакват нашите домакини. Тук ще посетим аквариум, за да наблюдаваме морската фауна в нейния естествен хабитат – делфини, акули, костенурки и много видове риби. Организиран обяд и завръщане в Картахена. Нощувка. Свободно време за вечеря и почивка.</div>
	},
	{
		title: "Ден 13",
		date: "17 ноември 2022 г.",
		destination: "Картахена де Индиас – Панама сити",
		others: "",
		text: <div>Закуска (поради по-ранното отлитане е възможно закуската да бъде сух пакет) и трансфер до летището, за да вземем директен полет до столищата на Панама. Пристигане на летище Токумен в Панама сити, трансфер и настаняване в хотел <a className={classes.textLink} href="http://www.plazapaitillainnpanamacity.com/" target="_blank">Plaza Paitilla Inn 4*</a>, или подобен. Градът предлага многобройни кулинарни алтернативи и искаме всеки един от вас самостоятелно да открие любимата си храна и място.</div>
	},
	{
		title: "Ден 14",
		date: "18 ноември 2022 г.",
		destination: "Панама сити – Панамски канал",
		others: "",
		text: <div>Закуска в хотела. След това ще се отправим към стария град, наречен Каско Антигуо, за да видим неповторимата му колониална архитектура. По-късно ще се насочим към зоната на Панамския канал. В посетителския център Мирафлорес ще се запознаем с функционирането на канала, ще научим много неща за историята му, ще видим и някои от шлюзовете му и ще наблюдаваме отблизо преминаващите кораби. В този ден храненията за обяд и вечеря се организират самостоятелно. Нощувка в хотела.</div>
	},
	{
		title: "Ден 15",
		date: "19 ноември 2022 г.",
		destination: "Панама сити – Гамбоа (индианска общност ембера)",
		others: "(обяд)",
		text: <div>След закуска, в последния ден от нашето пътуване, ще се отправим към джунглите на Панама, за да се запознаем отблизо с живота на една от малкото автентични и все още запазени индиански общности, тази на индианците ембера. От парка Чагрес ще се качим на моторни лодки (споделени), за да се отправим по река Чагрес и нейните притоци към земите на племето. Пеша ще пресечем част от гъстата тропическа джунгла, за да достигнем до селището, а там вождът ще ни разкаже за живота и обичаите на своите хора, и ще се насладим на техните танци и кухня. Ще ни сервират традиционен лек обяд, приготвен на място от племето, и дори ще имаме възможност да боядисаме лицата си с естествени пигменти (по желание), които се използват от индианците. След тази ни среща с миналото, ще се завърнем обратно в цивилизацията. Нощувка в хотела. Самостоятелна вечеря.</div>
	},
	{
		title: "Ден 16",
		date: "20 ноември 2022 г.",
		destination: "Панама сити – София",
		others: "",
		text: <div>Закуска, свободно време и трансфер до летището. Полет до България с прекачване във Франкфурт. Поради голямата часова разлика, пристигането ни в София ще е на 21 ноември.</div>
	}
];

const otherData = [
    {
		title: "Предимства на нашата програма",
		date: "",
		destination: "",
		others: "",
		text: (
            <div>
                <li>Богата и балансирана авторска програма с качествени услуги;</li>
                <li>3 последователни нощувки във всеки един от град от програмата, във внимателно селектирани хотели;</li>
                <li>Внимание към всеки детайл;</li>
                <li>Нашият стил на пътуване изключва продажба на място на допълнителни екскурзии, мероприятия, както и организирани посещения на сувенирни и други магазини;</li>
                <li>Прогамите ни са изчерпателни и не се налагат допълнителни екскурзии и мероприятия за опознаване на дестинациите;</li>
                <li>Отлично екскурзоводско обслужване от местни екскурзоводи с превод на български;</li>
                <li>Опитен водач от България през цялото време, на разположение 24 часа, със страст към дестинацията;</li>
                <li>Пътуване в малка група;</li>
                <li>Допълнителни културни, исторически, социални и други разяснения извън основното екскурзоводско обслужване;</li>
                <li>Допълнителни малки бонуси и изненади по време на пътуването;</li>
                <li>Бързи резервации и потвърждение, както и изчерпателно съдействие с информация за всичко необходимо по организацията на пътуването.</li>
            </div>
        )
	},
	{
		title: "Цената включва",
		date: "",
		destination: "",
		others: "",
		text: (
            <div>
                <div className={classes.bold}>Полети в икономична класа:</div>

                <li>Международен полет от София до Богота с прекачване във Франкфурт на Майн, с включени летищни такси, 1 бр. ръчен багаж и 1 бр. чекиран багаж до 23 кг.</li>

                <li>Вътрешни полети: Богота – Армения; Армения – Меделин (с прекачване в Богота); Меделин – Картахена с включени летищни такси, 1 бр. ръчен багаж и 1 бр. чекиран чагаж до 20 кг.</li>

                <li>Международен полет от Картахена до Панама сити с включени летищни такси, 1 бр. ръчен багаж и 1 бр. чекиран багаж до 20 кг.</li>

                <li>Международен полет от Панама сити до София с прекачване във Франкфурт на Майн, с включени летищни такси, 1 бр. ръчен багаж и 1 бр. чекиран багаж до 23 кг.</li>
            
                <div className={classes.bold}>15 нощувки в селектирани 4* и 5* хотели в Колумбия и Панама</div>

                <li>Богота: Holiday Inn Express – Parque la 93, 4* или подобен</li>

                <li>Саленто: Salento Рeal, 4* или подобен</li>

                <li>Меделин: Estelar Milla de Oro, 5* или подобен</li>

                <li>Картахена: Nacar Cartagena, Curio Collection by Hilton, 4 SUP* или подобен</li>

                <li>Панама сити: Plaza Paitilla Inn, 4* или подобен</li>

                <div className={classes.bold}>Изхранване:</div>

                <li>15 закуски в избраните хотели</li>

                <li>10 (включително лек обяд в индианската общност ембера) обяда без напитки в селектирани ресторанти по програмата</li>

                <li>4 вечери без напитки в селектирани ресторанти по програмата или в хотела</li>

                <div className={classes.bold}>Транспорт:</div>

                <li>Всички трансфери летище – хотел и обратно, както и самостоятелен транспорт (съобразен с броя на пътуващите в групата) за всички турове описани в програмата.</li>

                <li>Друг вид транспорт, описан в програма – самолети, метро, джипове, моторна лодка, лифтове / зъбчата железница (фуникулер), мототакси (тук-тук) и електрически стълби.</li>

                <div className={classes.bold}>Всички екскурзии с включени входни такси, описани в програмата:</div>

                <li>Богота: панорамна обиколка на центъра и стария квартал Канделария; изкачване с лифт или зъбчата железница (фуникулер) до хълма Монсерате; вход в Музей на златото;</li>
                <li>Екскурзия до лагуната Гуатавита;</li>
                <li>Вход в солната катедрала в Сипакира;</li>
                <li>Екскурзия до Санта Роса де Кабал: посещение на кафеена плантация с дегустация;</li>
                <li>Екскурзия до долината Кокора в националния парк Лос Невадос;</li>
                <li>Вход в Ботаническата градина на Киндио;</li>
                <li>Панорамна обиколка на Саленто и Филандия;</li>
                <li>Меделин: панорамна обиколка на града; билет за метро, лифт и електрически стълбища; парк Арви и колона 13;</li>
                <li>Екскурзия до Гуатапе с вход за изкачване на скалата и обиколка на Гуатапе с мототакси (тук-тук);</li>
                <li>Картахена де Индиас: вход за крепостта Сан Фелипе де Барахас, и манастира и църквата Сан Педро Клавер; пешеходна панорамна обиколка на стария град;</li>
                <li>Екскурзия с моторна лодка до островите Росарио и посещение на аквариума;</li>
                <li>Панама сити: панорамна обиколка на Стария град; вход в посетителския център Мирафлорес на Панамския канал;</li>
                <li>Екскурзия с моторна лодка до индианската общност ембера.</li>

                <div className={classes.bold}>Лицензирани местни екскурзоводи на испански с превод на български</div>
                <div className={classes.bold}>Професионален български водач-преводач на място</div>
                <div className={classes.bold}>Медицинска застраховка на ЗК &quot;ЛЕВ ИНС&quot; с покритие 15 000 евро (за лица до 70 г.)</div>
            </div>
        )
	},
    {
		title: "Цената не включва",
		date: "",
		destination: "",
		others: "",
		text: (
            <div>
                <li>Допълнителни хранения извън програмата;</li>
                <li>Напитки по време на включените обяди и вечери;</li>
                <li>Такса за напускане на Колумбия и Панама (приблизително 19 щатски долара за Колумбия и 40 щатски долара за Панама, заплаща се на място в брой в щатски долари);</li>
                <li>Допълнителни мероприятия извън програмата;</li>
                <li>Фото и видеотакси за заснемане по туристическите обектите;</li>
                <li>Такса / бакшиш за обслужване от местен екскурзовод/и и шофьор/и (при добро обслужване приблизително до 5 американски долара на ден. Сумата се заплаща на място);</li>
                <li>Разходи от личен характер като интернет, минибар, пиколи и др.;</li>
                <li>Доплащане за избор на седалка и класа в самолетни полети;</li>
                <li>Застраховка отмяна на пътуването с “Лев Инс” (възстановява заплатената сума по здравословни и други доказуеми причини);</li>
                <li>Мед. застраховка с покритие 15 000 евро за лица от 70 до 79 г. – доплащане;</li>
                <li>Мед. застраховка с покритие 15 000 евро за лица от 79 до 85 г. – доплащане;</li>
                <li>Тестване или други други документи свързани с акутно заболяване включително Covid-19 (PCR, антигенни тестове и др.);</li>
                <li>Евентуално увеличение на такса гориво и/или летищни такси, дължимо за всички резервации за полети, за които се начислява;</li>
                <li>Туристически такси за престой в хотел/и от програмата, в случай че са въведени такива между датата на сключване на Договор за туристически пакет и пътуването. Тези такси се заплащат задължително на място на рецепция в съответния хотел от всички пътуващи;</li>
                <li>Промяна на цената на вътрешни полети. Към 31.03.2022 г. цената на вътрешните полети и международния полет Картахена – Панама сити с включени летищни такси, 1 бр. ръчен багаж и 1 бр. чекиран багаж до 20 кг. е 1 225.00 лева на човек. Това е калкулираната сума в общата пакетна цена на екскурзията. При повишаване на тарифата или на размера на летищните такси от страна на превозвача, се начислява доплащане към общата пакетна цена.</li>
            </div>
        )
	},
    {
		title: "Полетна информация",
		date: "",
		destination: "",
		others: "",
		text: (
            <div>
                <table>
                    <tr>
                        <th>Авиокомпания</th>
                        <th>Полети</th>
                        <th>Дата</th>
                        <th>Дестинации</th>
                        <th>Излитане</th>
                        <th>Кацане</th>
                    </tr>
                    <tr>
                        <td>Луфтханза</td>
                        <td>LH 1429</td>
                        <td>05-11-22</td>
                        <td>София – Франкфурт на Майн</td>
                        <td>06:50ч.</td>
                        <td>08:25ч.</td>
                    </tr>
                    <tr>
                        <td>Луфтханза</td>
                        <td>LH 542</td>
                        <td>05-11-22</td>
                        <td>Франкфурт на Майн – Богота</td>
                        <td>13:10ч.</td>
                        <td>19:30ч.</td>
                    </tr>
                    <tr>
                        <td>Авианка</td>
                        <td>AV 4806</td>
                        <td>08-11-22</td>
                        <td>Богота – Армения</td>
                        <td>09:16 ч.</td>
                        <td>10:16 ч.</td>
                    </tr>
                    <tr>
                        <td>Авианка</td>
                        <td>AV 4806</td>
                        <td>11-11-22</td>
                        <td>Армения – Богота</td>
                        <td>09:58ч.</td>
                        <td>10:55ч.</td>
                    </tr>
                    <tr>
                        <td>Авианка</td>
                        <td>AV 9316</td>
                        <td>11-11-22</td>
                        <td>Богота – Меделин</td>
                        <td>12:35ч.</td>
                        <td>13:37ч.</td>
                    </tr>
                    <tr>
                        <td>Авианка</td>
                        <td>AV 9386</td>
                        <td>14-11-22</td>
                        <td>Меделин – Картахена</td>
                        <td>18:29ч.</td>
                        <td>19:38ч.</td>
                    </tr>
                    <tr>
                        <td>Копа Еърлайнс</td>
                        <td>CM 160</td>
                        <td>17-11-22</td>
                        <td>Картахена – Панама Сити</td>
                        <td>09:36ч.</td>
                        <td>10:50ч.</td>
                    </tr>
                    <tr>
                        <td>Луфтханза</td>
                        <td>LH 4395</td>
                        <td>20-11-22</td>
                        <td>Панама Сити – Франкфурт на Майн</td>
                        <td>20:15ч.</td>
                        <td>
                            <div>13:35ч.</div>
                            21-11-22
                        </td>
                    </tr>
                    <tr>
                        <td>Луфтханза</td>
                        <td>LH 1430</td>
                        <td>21-11-22</td>
                        <td>Франкфурт на Майн – София</td>
                        <td>15:00ч.</td>
                        <td>18:10ч.</td>
                    </tr>
                </table>

                <div>
                    <i>*Полетните разписания са информативни и подлежат на препотвърждение. Те могат да бъдат променяни от авиокомпаниите след датата на публикуването им.</i>
                </div>
                
                <i>**Всички полетни разписания са в местно време на съответната дестинация.</i>
            </div>
        )
	},
    {
		title: "Условия за записване и анулиране",
		date: "",
		destination: "",
		others: "",
		text: (
            <div>
                <div className={classes.bold}>Условия за записване:</div>
                <li>Депозит до 3 (три) работни дни от потвърждение на резервацията в размер на 2 000.00 лв.</li>
                <li>Окончателно плащане до 61 дни преди датата на заминаване.</li>
                <li>Плащането се извършва в лева по банков път.</li>

                <div className={classes.bold}>Анулации и неустойки:</div>
                <li>До 121 календарни дни (или до 07.07.2022 г.) преди датата на пътуването – такса резервация в размер на 50 лв. За всяка промяна след първоначалното записване се удържа такса в размер на 50 лв. Тази сума се дължи, ако пътуващият прекрати / анулира договора си по своя инициатива до 121 дни преди датата на отпътуване.</li>
                <li>От 120 до 91 календарни дни (или до 06.08.2022 г.) преди датата на пътуването – 10% от общата сума по договор;</li>
                <li>От 90 до 61 календарни дни (или до 05.09.2022 г.) преди датата на пътуването – 30% от общата сума по договор;</li>
                <li>От 60 до 41 календарни дни (или до 25.09.2022 г.) преди датата на пътуването – 50% от общата сума по договор;</li>
                <li>От 40 до 21 календарни дни (или до 15.10.2022 г.) преди датата на пътуването – 80% от общата сума по договор;</li>
                <li>По-малко от 20 календарни дни преди датата на пътуването – 100 % от общата стойност на пакета;</li>
                <li>Преотстъпване на пътуването на друго лице и смяна на име без неустойка – до 31 дни преди заминаване.</li>
                <li>При анулация на пътуването от страна на Туроператора, сумата се възстановява в 7-дневен срок от анулацията.</li>
                <li>При сключена полицата „Отмяна на пътуване“, включително и при положителен PCR тест, сумата се възстановява спрямо Общите условия ЗК &quot;ЛЕВ ИНС&quot;.</li>
            </div>
        )
	},
    {
		title: "Необходими документи",
		date: "",
		destination: "",
		others: "",
		text: (
            <div>
                <li>Задграничен паспорт с валидност минимум 6 месеца след датата на приключване на пътуването;</li>
                <li>Всички туристи до 18 г., пътуващи с един или без родител, представят освен международен паспорт, нотариално заверена декларация от единия или от двамата родители и акт за раждане, както и копие от него.</li>
                <li>Задължително 24 часа преди заминаване да Колумбия, се попълва онлайн миграционен формуляр, който се пази и представя при напускане на страната;</li>
            </div>
        )
	},
    {
		title: "Медицински изисквания (към 01.03.2022 г.)",
		date: "",
		destination: "",
		others: "",
		text: (
            <div>
                Без значение до къде и за колко време ще пътувате, моля сверявайте актуалната информация за всяка страната преди резервация и поне още веднъж непосредствено преди самото пътуване. Тя може да претърпи съществена промяна в рамките на съвсем кратки срокове.
                
                <div className={classes.bold}>Колумбия:</div>
                <li>24 часа преди заминаване за Колумбия, пътниците трябва да попълнят онлайн формуляр, който се представя при пристигане;</li>
                <li>Всички пълнолетни пътници, които влизат в Колумбия, трябва да имат завършен ваксинационен курс за COVID-19, като последната доза трябва да е поставена поне 14 дни преди датата на заминаване; Неваксинирани граждани не се допускат до страната. Чуждестранни посетители, които са започнали, но не са завършили своя ваксинационен курс, се допускат в страната с негативен PCR тест, извършен 72 часа преди пристигане.</li>

                <div className={classes.bold}>Панама:</div>
                <li>При пристигане в страната задължително се представя здравна декларация, попълнена онлайн;</li>
                <li>От 22 януари 2022 г. панамското правителство счита за завършен ваксинационен курс поставени 3 ваксини, с изключение на ваксината Jansen, която изисква 2 дози. Всички неваксинирани или частично ваксинирани пътници трябва да представят негативен PCR или антигенен тест, извършен 72 часа преди пристигане.</li>
            </div>
        )
	},
    {
		title: "Важно за програмата",
		date: "",
		destination: "",
		others: "",
		text: (
            <div>
               <li>Минимален брой участници: 12</li>
                <li>Срок за събиране на група и уведомление за несъбран минимум: 91 дни преди датата на пътуването или 06.08.2022 г. Промяна на пакетната цена е възможна при промяна на транспортни разходи (гориво), летищни, пристанищни и други такси; данъчни ставки; промяна с повече от 3% на валутния курс в периода между датата на сключване на договора и отпътуването; непредвидено покачване на цените от страна на партньорите на туроператора, както и в други обективно наложителни случаи. В тези случаи туроператорът може да поиска тези допълнителни разходи да бъдат поети от пътуващия. Увеличението на цената на пакета, но с не повече от 8 %, вследствие на обективно посочени причини не може да бъде повод за отказ от страна на пътуващия.</li>
                <li>Пътуването не е подходящо за лица с ограничена подвижност.</li>
                <li>Посочените пакетни цени са калкулирани при курс на лев към евро 1.00 EUR = 1.95583 BGN.</li>
                <li>Авиокомпаниите си запазва правото за смяна на часовете на излитане и кацане, за което туроператорът ще информира своевременно потребителите.</li>
                <li>Туроператорът не носи отговорност при промяна на музейните такси и работното време на музеите. Туроператорът си запазва правото на промени в последователността на изпълнение на програмата по независещи от него причини и не носи отговорност за пътуващи, недопуснати от съответните гранични власти.</li>
                <li>При възникване на нови промени относно визови, здравни, санитарни и други изисквания, туроператорът своевременно ще информира пътуващите за всички актуални процедури и препоръки касаещи влизането и престоя в Колумбия и Панама, но не по късно от 7 (седем) дни преди отпътуване.</li>
                <li>Туроператорът си запазва правото, при необходимост, да променя хотелите упоменати в програмата с подобни от същата категория.</li>
                <li>Туроператорът не носи отговорност при въвеждане на нови или повишаване на вече съществуващи държавни такси.</li>
                <li>Хотелското настаняване в Колумбия и Панама е след 15 часа, а напускането е до 11 часа.</li>

                <div className={classes.bold}>Застраховка „Отмяна от пътуване“:</div>

                <li>Туроператорът предоставя възможност за сключване на допълнителна  застраховка “Отмяна на пътуване” със ЗАД &quot;Лев Инс&quot;, която е защита в случай на неочаквано възпрепятстване на пътуването от здравословен, служебен или семеен характер, включително Covid-19. Застраховката  покрива разходите за анулиране на пътуването, както и на разходите за заплатени, но неконсумирани услуги по време на пътуването, ако то е било прекъснато. За срокове за сключване и размер на на застрахователната премия, моля обръщайте се към нас по мейл.</li>
                <li>Отмяна на пътуването поради COVID-19: Ако застрахованото лице се разболее от COVID-19 или е поставено под карантина поради съмнение за заболяване и следователно трябва да отмени планирано пътуване, застраховката покрива възстановяването на разходите за анулиране на пътуването. Заболяването на съпруг/а или близък роднина, който не пътува, също се счита за причина за анулиране на пътуването, при условие че лицето има животозастрашаващо състояние поради COVID- 19 и се нуждае от интензивни грижи в болница.</li>
                <li>Други причини за отмяна на пътуването, покрити от застраховката:</li>
                <li>Включват медицински и немедицински причини, съкращаване от работа и други описани в Общите условия на застрахователя.</li>

                <div className={classes.bold}>Важни уточнения за събития извън обхвата на застраховките:</div>

                <li>Издадени предупреждения за пътуване, страх за предприемане на пътуване или груба небрежност остават като изключени събития;</li>
                <li>Пандемия и епидемия продължават да съществуват като изключения в Общите условия. Например ако пътуването бъде отменено от туроператора заради COVID-19, това събитие е изключен риск по застрахователното покритие;</li>
                <li>Пътуване до държави/райони, за които властите са издали официални предупреждения за пътуване (степен 5 или 6);</li>
                <li>Отказ за спазване или несъобразяване с правила и разпоредби в дестинацията;</li>
                <li>Груба небрежност и умишлено заразяване с COVID-19.</li>
            </div>
        )
	},
    {
		title: "Обща информация за Панама и Колумбия (към 01.03.2022г.)",
		date: "",
		destination: "",
		others: "",
		text: (
            <div>
                <li>Местна валута – Паричната единица на Колумбия е колумбийско песо = 100 сентавос. В Панама се използват панамската балбоа = 100 сентисимос и щатски долари. Не се препоръчва носенето на евро, тъй като курсът му с местните валути е неизгоден. Обмяна на пари на място става в банки или обменни бюра. Препоръчително всеки пътуващ да има малка наличност в кеш на американски долари.</li>
                <li>Валутен курс: 1000 колумбийски песос = 0.45 лева, 1 панамска балбоа = 1 американски долар = 1.78 лева</li>
                <li>Средни температури през месец ноември: На карибското крайбрежие и в Панама температурите са високи. През ноември в Картахена де Индиас и Панама сити дневните температури са около 28-30°C, а минималните около 26°C. В Меделин за същия сезон температурите са между 18-25°C. В Богота, поради надморската ѝ височина, максималните дневни температури през ноември са около 18°C, като рядко надвишават 20°C. В Саленто средната дневна температура е около 21°C. Препоръчително е да се носят връхни дрехи, както и дъждобран, чадър, тъй като има веротност за ежедневни краткотрайни, но напоителни валежи. Препоръчително е използването на репелент за комари.</li>
                <li>Часова разлика между България и Колумбия, България и Панама – минус 7 часа. Колумбия и Панама не променят часовото си време;</li>
                <li>Електрическо напрежение, контакти и нужда от адаптор § преходник – В Колумбия наярежението е 110V, а в Панама – 120V. И в двете държави контактите са тип А/В. За използването на електронни устройства от България е необходим адаптор § преходник на напрежение. Моля убедете се предварително, че Вашето устройство може да работи на местното електрическо напрежение;</li>
                <li>Чешмяната вода е годна за пиене в голяма част от Колумбия и Панама. Препоръката ни е, когато можете да се придържате към бутилирана вода и най-вече в по-малките населени места.</li>
                <li>Безопасност и сигурност: Големите градове на Колумбия, като Богота, Меделин, Картахена и други като това важи и за Панама, могат да бъдат определени като спокойни за посещение, с изключение на някои зони и крайни квартали. Препоръчително е да се избягват неосветени и безлюдни улици, както и да не се показват скъпи вещи, като смартфони, камери, бижута. Да не се използват таксиметрови услуги без предварителна резервация. Не е препоръчително използването на градски транспорт, поради опасност от джебчии.</li>
                <li>За повече информация може да разгледате секцията „Пътувам за ...“ на българското Министерство на външните работи и да се запознаете с дадените препоръки за Колумбия и Панама;</li>
            </div>
        )
	}
]

const images = [
    {
        title:"Bogota",
        small:"https://etclub.bg/images/columbia-panama-2022/offer-bogota-small.jpeg",
        large:"https://etclub.bg/images/columbia-panama-2022/offer-bogota-large.jpeg"
    },
    {
        title:"Sipakira",
        small:"https://etclub.bg/images/columbia-panama-2022/offer-sipakira-small.jpeg",
        large:"https://etclub.bg/images/columbia-panama-2022/offer-sipakira-large.jpeg"
    },
    {
        title:"Salento",
        small:"https://etclub.bg/images/columbia-panama-2022/offer-salento-small.jpeg",
        large:"https://etclub.bg/images/columbia-panama-2022/offer-salento-large.jpeg"
    },
    {
        title:"Valle del Cocora",
        small:"https://etclub.bg/images/columbia-panama-2022/offer-valledecocora-small.jpeg",
        large:"https://etclub.bg/images/columbia-panama-2022/offer-valledecocora-large.jpeg"
    },
    {
        title:"Medelin",
        small:"https://etclub.bg/images/columbia-panama-2022/offer-medelin-small.jpeg",
        large:"https://etclub.bg/images/columbia-panama-2022/offer-medelin-large.jpeg"
    },
    {
        title:"Cartagena de Indias",
        small:"https://etclub.bg/images/columbia-panama-2022/offer-cartagena-small.jpeg",
        large:"https://etclub.bg/images/columbia-panama-2022/offer-cartagena-large.jpeg"
    },
    {
        title:"Panama City",
        small:"https://etclub.bg/images/columbia-panama-2022/offer-panama-small.jpeg",
        large:"https://etclub.bg/images/columbia-panama-2022/offer-panama-large.jpeg"
    }
]
const Offer = () => {

	return (
		<div className={classes.offerWrapper}>
            <div className={classes.galleryWrapper}>
                    {
                        images.map((image, index) => (
                            <ModalImage
                                key={`image-${index}`}
                                small={image.small}
                                large={image.large}
                                alt={image.title}
                            />
                        ))
                    }
            </div>

            <div className={classes.programWrapper}>
                <div className={classes.description}>
                    <div className={classes.descriptionSection}>


                    <h1 className={classes.title}>Приключение за модерни конкистадори</h1>
                    <h2 className={classes.subTitle}>Колумбия и Панама</h2>
                    <h2 className={classes.subTitleDate}>05.11.2022 - 20.11.2022</h2>

                    <h3>Защо да изберете Колумбия и Панама?</h3>

                    <div>
                        Няма да е пресилено, ако кажем, че Колумбия е скритото съкровище на Южна Америка със своите изумителни гледки и очарователни градчета. Известна като“Тибет на Южна Америка”, днес страната се отърсва от масовата представа за опасна и затворена дестинация и е готова да разкрие на посетителите си своите добре пазени съкровища. Потопетете се в това незабравимо приключение на екзотика и контрасти, и пътувайте там, където не всеки е бил. Панама от своя страна ще ви впечатли с модерната си архитектура и автентично запазени индиански общности в джунглите.
                    </div>

                    <div>
                        С много внимание и страст сме Ви подготвили едно незабравимо пътешествение до тези красиви страни, подсилили сме го с ароматно колумбийско кафе, легенди за конкистадори и злато, и Вие ще трябва да го преживеете чрез очарователните усмивки и госпоприемството на местните хора. Ще се изкачим на високо, ще плаваме с лодка по море и река, ще пресичаме джунгли, ще се возим на джипове.
                    </div>

                    <div className={classes.bold}>
                        Приключението е гарантирано!
                    </div>

                    <div className={classes.priceRow}>
                        Цена: 

                        <span className={classes.notdiscounted}> 9405лв </span>

                        <span className={classes.discounted}>9115лв</span>
                    </div>
                    </div>
			        {
			        	otherData.map((dayInfo, index) => (
                            <CollapseSectionSimple
                                key={index}
                                day={dayInfo.title}
                                date={dayInfo.date}
                                title={dayInfo.destination + dayInfo.others}
                                content={dayInfo.text}    
                            />
                        ))
			        }   
                </div>

                <div className={classes.program}>
			        {
			        	data.map((dayInfo, index) => (
                            <CollapseSectionSimple
                                key={index}
                                day={dayInfo.title}
                                date={dayInfo.date}
                                title={dayInfo.destination + dayInfo.others}
                                content={dayInfo.text}    
                            />
                        ))
			        }
                </div>

                { null && (
                    <div>
			            {
			            	data.map((dayInfo, index) => (
                                    <CollapseSection
                                    key={index}
                                    day={dayInfo.title.substring(4)}
                                    date={dayInfo.date}
                                    title={dayInfo.destination + dayInfo.others}
                                    content={dayInfo.text}    
                                />
                            ))
			            }
                    </div>
                )
                }
            </div>
		</div>
	)

}

export default Offer;
